

import React from "react";
import { createPortal } from "react-dom";

const Popup = ({
  open,
  type = "success", // "success" | "error"
  title,
  message,
  onClose,
  primaryAction, // optional callback
}) => {
  if (!open) return null;

  const isSuccess = type === "success";

  const popupUI = (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999, // higher than sticky bar
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.45)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Icon */}
        <div
          style={{
            fontSize: "48px",
            marginBottom: "10px",
            color: isSuccess ? "#28a745" : "#dc3545",
          }}
        >
          {isSuccess ? "✓" : "✕"}
        </div>

        {/* Title */}
        <h3
          style={{
            margin: "0 0 10px 0",
            color: isSuccess ? "#28a745" : "#dc3545",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontWeight: "600",
          }}
        >
          {title || (isSuccess ? "Success" : "Error")}
        </h3>

        {/* Message */}
        <h4
          style={{
            margin: "0 0 20px 0",
            color: "#333",
            fontFamily: "Montserrat",
            fontSize: "14px",
            lineHeight: "1.5",
            textAlign: "center",
          }}
        >
          {message}
        </h4>

        {/* Action */}
        <button
          onClick={() => {
            if (primaryAction) primaryAction();
            onClose();
          }}
          style={{
            backgroundColor: isSuccess ? "#28a745" : "#dc3545",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "10px 20px",
            cursor: "pointer",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          OK
        </button>
      </div>
    </div>
  );

  // 🔥 THIS IS THE ONLY IMPORTANT CHANGE
  return createPortal(popupUI, document.body);
};

export default Popup;